import { render, staticRenderFns } from "./SupplierInvoicesTable.vue?vue&type=template&id=972f88be&scoped=true&"
import script from "./SupplierInvoicesTable.vue?vue&type=script&lang=js&"
export * from "./SupplierInvoicesTable.vue?vue&type=script&lang=js&"
import style0 from "./SupplierInvoicesTable.vue?vue&type=style&index=0&id=972f88be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972f88be",
  null
  
)

export default component.exports